export enum FiChecklist2ReportTimePeriodType {
    Today = 0,
    LastWeek = 1,
    LastMonth = 2,
    LastQuarter = 3,
    LastYear = 4,
    Last24hrs = 5, // recent activity special case
    Custom = 100,
}
